import { Navigation } from "./navigation/navigation";
import { Logo } from "./logo";
import { useStrapiFetch } from "../../hooks/use-strapi-fetch";
import type { HeaderType } from "../../types/strapi-types";

export function Header() {
	const { data } = useStrapiFetch<HeaderType>("/api/header?populate=*");

	if (!data) {
		return null;
	}

	const { logo } = data;

	return (
		<div className="sticky top-0 z-50 bg-white">
			<header className="relative container mx-auto px-4 flex justify-between gap-6 md:h-20 h-14">
				<Logo {...logo} />

				<Navigation />
			</header>
		</div>
	);
}
